import React from 'react';
import { useT } from '../i18n';

/**
 * CF-BONUS Ticket B — /bonus-terms page: the nine approved points.
 *
 * Copy source of truth: plans/CF-BONUS-TERMS-V1-DRAFT.md (PL-approved TG #11925, Scorer content
 * review closed 1240). Point 8 renders the PENDING-REPLACEMENT wording, which was authorised to
 * ship exactly WITH this ticket — i.e. once the deposit surface can read live availability.
 *
 * Every sentence maps to a mechanical rule in the engine; no line here promises more than the
 * code does. The two disclosures Scorer made mandatory are points 4 (D2 excess-forfeit) and
 * 5 (D1 withdrawal forfeits). They are not optional and are pinned by
 * tests/cf-bonus-i18n-semantics.spec.ts in all four locales.
 *
 * Unlike /terms and /privacy, this page carries NO "English is the controlling version" notice:
 * those pages render an English legal body to non-English users, whereas these terms are fully
 * translated in every locale we ship (same reasoning that dropped the notice for the German
 * build in CF-GERMAN-LEGAL-TRANSLATE-V1).
 */

const POINTS = 9;

export function BonusTermsPage() {
    const t = useT();
    return (
        <div style={{ minHeight: '100vh', background: '#070b14', color: '#cbd2dd', padding: '24px 16px' }}>
            <div style={{ maxWidth: 720, margin: '0 auto', fontSize: 14 }}>
                <a
                    href="/"
                    style={{
                        display: 'inline-block', color: 'var(--gold)', textDecoration: 'none',
                        marginBottom: 16, fontSize: 14,
                    }}
                >
                    {t('common.back_to_cricketflip')}
                </a>

                <h1 style={{ color: '#fff', marginTop: '0.2em', marginBottom: '0.8em', fontSize: '1.4em' }}>
                    {t('bonus.terms.title')}
                </h1>

                <ol style={{ margin: '0 0 1em 1.25em', padding: 0, lineHeight: 1.65 }}>
                    {Array.from({ length: POINTS }, (_, i) => (
                        <li key={i} style={{ marginBottom: '0.9em' }}>
                            {t(`bonus.terms.pt${i + 1}`)}
                        </li>
                    ))}
                </ol>
            </div>
        </div>
    );
}
